import { render, staticRenderFns } from "./AdminSchedulesModalDeleteSchedule.vue?vue&type=template&id=affd6912&scoped=true"
import script from "./AdminSchedulesModalDeleteSchedule.vue?vue&type=script&lang=js"
export * from "./AdminSchedulesModalDeleteSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affd6912",
  null
  
)

export default component.exports